import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./app.css";
import "bootstrap-icons/font/bootstrap-icons";
import confirmPlugin from "./plugins/confirm";
import toastPlugin from "./plugins/toast";
import axiosPlugin from "./plugins/axios";
import authStatusPlugin, { authStatus } from "./plugins/authStatus";
import imageUrlPlugin from "./plugins/imageUrl";

Vue.config.productionTip = false;

Vue.use(confirmPlugin);
Vue.use(toastPlugin);
Vue.use(axiosPlugin);
Vue.use(authStatusPlugin);
Vue.use(imageUrlPlugin);

new Vue({
  router,
  store,
  created() {
    authStatus.refresh();
  },
  render: (h) => h(App),
}).$mount("#app");
